import CustomerPaymentMethodAdmin from 'src/adminPanel/entities/office/paymentMethod/CustomerPaymentMethod';
import callApi, { CallApiResult, getCustomerId } from 'src/api';

export const fetchAllCustomerPaymentMethods = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/customer/' + customerId + '/paymentmethods';
    return callApi(endpoint);
};

export const fetchAllAdminCustomerpaymentMethods = () => {
    const customerId = getCustomerId();
    return callApi(`/api/admin/customerPaymentMethod/${customerId}/list`);
};

export const addCustomerPaymentMethod = (customerPaymentMethod: CustomerPaymentMethodAdmin): Promise<CallApiResult> => {
    const endpoint = '/api/admin/customerPaymentMethod/add';
    return callApi(endpoint, { method: 'POST', data: customerPaymentMethod });
};

export const deactivateCustomerPaymentMethod = (customerPaymentMethodId: number): Promise<CallApiResult> => {
    const endpoint = '/api/admin/customerPaymentMethod/' + customerPaymentMethodId + '/deactivate';
    return callApi(endpoint, { method: 'POST' });
};
